import { useMeetingMode } from '@renderer/hooks/settings/useMeetingMode'
import type { MeetingMode } from '@shared/types/AudioNoteSettings'
import { useOpenMeetingsSettings } from '../../../utils/use-open-meetings-settings'

const NOTICE_COPY: Record<MeetingMode, string> = {
  autopilot: 'Highlight will automatically transcribe your meeting. You can manage this in',
  notify: 'Highlight can automatically transcribe your meeting. You can customize this in',
  silent: 'You have Highlight silenced for meetings. You can manage this in',
}

/**
 * Bottom-of-hero copy explaining what the current Meeting Mode does to this
 * meeting, with a deeplink into Settings to change it. Hidden by the caller
 * while the audio-permissions card is showing in the same slot.
 */
export function MeetingModeNotice() {
  const { meetingMode } = useMeetingMode()
  const openMeetingsSettings = useOpenMeetingsSettings()

  return (
    <p className="text-foreground-secondary type-prose-sm mb-3 text-balance text-center font-medium">
      {NOTICE_COPY[meetingMode]} <MeetingsSettingsLink onClick={openMeetingsSettings} />
    </p>
  )
}

/* bg-transparent/p-0/border-0: preflight is off, so a bare button falls back
   to the UA's grey ButtonFace fill and default padding/border. */
export function MeetingsSettingsLink({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      // Explicit color: the composer's `before` slot inherits a washed-out
      // foreground, so anything relying on inheritance there goes invisible.
      className="text-foreground-secondary hover:text-foreground inline cursor-pointer border-0 bg-transparent p-0 font-medium underline decoration-from-font transition-colors duration-150"
    >
      Settings → Meetings
    </button>
  )
}
